export default [
  {
    "id": "mat-enem-0856",
    "numero": 2356,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Como não são adeptos da prática de esportes, um grupo de amigos resolveu fazer um torneio de futebol \nutilizando videogame. Decidiram que cada jogador joga uma única vez com cada um dos outros jogado-\nres. O campeão será aquele que conseguir o maior número de pontos. Observaram que o número de \npartidas jogadas depende do número de jogadores, como mostra o quadro: \n \n \n \nSe a quantidade de jogadores for 8, quantas partidas serão realizadas? \n \nA) 64 \nB) 56 \nC) 49 \nD) 36 \nE) 28",
    "alternativas": {
      "A": "64",
      "C": "49",
      "D": "36",
      "E": "28"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 856,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0857",
    "numero": 2357,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Um morador de uma região metropolitana tem 50% de probabilidade de atrasar-se para o trabalho quan-\ndo chove na região; caso não chova, sua probabilidade de atraso é de 25%. Para um determinado dia, o \nserviço de meteorologia estima em 30% a probabilidade da ocorrência de chuva nessa região. Qual é a \nprobabilidade de esse morador se atrasar para serviço no dia para o qual foi dada a estimativa de chu-\nva? \n \nA) 0,075 \nB) 0,150 \nC) 0,325 \nD) 0,600 \nE) 0,800",
    "alternativas": {
      "C": "0,325",
      "E": "0,800",
      "A": "0,075",
      "B": "0,150"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 857,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0858",
    "numero": 2358,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Uma empresa construirá sua página na internet \ne espera atrair um público de aproximadamente \num milhão de clientes. Para acessar essa pági-\nna, será necessária uma senha com formato a \nser definido pela empresa. Existem cinco op-\nções de formato oferecidas pelo programador \ndescritas no quadro, em que “L” e “D” represen-\ntam, respectivamente, letra maiúscula e digito. \n \n \n \nAs letras do alfabeto, entre as 26 possíveis, \nbem como os dígitos, entre os 10 possíveis, \npodem se repetir em qualquer das opções. \n \nA empresa quer escolher uma opção de formato \ncujo número de senhas distintas possíveis seja \nsuperior ao número esperado de clientes, mas \nque esse número não seja superior ao dobro do \nnúmero esperado de clientes. \n \nA opção que mais se adequa às condições da \nempresa é: \n \nA) I \nB) II \nC) III \nD) IV \nE) V",
    "alternativas": {
      "C": "III",
      "E": "V",
      "A": "I",
      "B": "II"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 858,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0859",
    "numero": 2359,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Às 17 h 15 min começa uma forte chuva, que \ncai com intensidade constante. Uma piscina em \nforma de um paralelepípedo retângulo, que se \nencontrava inicialmente vazia, começa a acu-\nmular a água da chuva e, às 18 horas, o nível \nda água em seu interior alcança 20 cm de altu-\nra. Nesse instante, é aberto o registro que libera \no escoamento da água por um ralo localizado \nno fundo dessa piscina, cuja vazão é constante. \nÀs 18 h 40 min a chuva cessa e, nesse exato \ninstante, o nível da água na piscina baixou para \n15 cm. \n \nO instante em que a água dessa piscina termi-\nnar de escoar completamente está compreendi-\ndo entre: \n \nA) 19 h 30 min e 20 h 10 min. \nB) 19 h 20 min e 19 h 30 min. \nC) 19 h 10 min e 19 h 20 min. \nD) 19 h e 19 h 10 min. \nE) 18 h 40 min e 19 h.",
    "alternativas": {
      "D": "19 h e 19 h 10 min.",
      "A": "19 h 30 min e 20 h 10 min.",
      "B": "19 h 20 min e 19 h 30 min.",
      "C": "19 h 10 min e 19 h 20 min."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 859,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0860",
    "numero": 2360,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Um garçom precisa escolher uma bandeja de \nbase retangular para servir quatro taças de es-\npumante que precisam ser dispostas em uma \núnica fileira, paralela ao lado maior da bandeja, \ne com suas bases totalmente apoiadas na ban-\ndeja. A base e a borda superior das taças são \ncírculos de raio. 4 cm e 5 cm, respectivamente. \n \n \n \nA bandeja a ser escolhida deverá ter uma área \nmínima, em centímetro quadrado, igual a: \n \nA) 192. \nB) 300. \nC) 304. \nD) 320. \nE) 400.",
    "alternativas": {
      "D": "320.",
      "E": "400.",
      "B": "300.",
      "C": "304."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 860,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0861",
    "numero": 2361,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Em uma cantina, o sucesso de venda no verão \nsão sucos preparados à base de polpa de fru-\ntas. Um dos sucos mais vendidos é o de mo-\nrango com acerola, que é preparado com  2/3 \nde polpa de morango e 1/3 de polpa de acerola. \n \nPara o comerciante, as polpas são vendidas em \nembalagens de igual volume. Atualmente, a \nembalagem da polpa de morango custa R$ \n18,00 e a de acerola, R$ 14,70. Porém, está \nprevista uma alta no preço da embalagem da \npolpa de acerola no próximo mês, passando a \ncustar R$ 15,30. \n \nPara não aumentar o preço do suco, o comerci-\nante negociou com o fornecedor uma redução \nno preço da embalagem da polpa de morango. \n \nA redução, em real, no preço da embalagem da \npolpa de morango deverá ser de: \n \nA) 1,20. \nB) 0,90. \nC) 0,60. \nD) 0,40. \nE) 0,30.",
    "alternativas": {
      "C": "0,60.",
      "D": "0,40.",
      "E": "0,30.",
      "A": "1,20."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 861,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0862",
    "numero": 2362,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Um casal realiza sua mudança de domicílio e \nnecessita colocar numa caixa de papelão um \nobjeto cúbico de 80 cm de aresta, que não pode \nser desmontado. Eles têm à disposição cinco \ncaixas, com diferentes dimensões, conforme \ndescrito: \n \n- Caixa 1: 86 cm x 86 cm x 86 cm \n- Caixa 2: 75 cm x 82 cm x 90 cm \n- Caixa 3: 85 cm x 82 cm x 90 cm \n- Caixa 4: 82 cm x 95 cm x 82 cm \n- Caixa 5: 80 cm x 95 cm x 85 cm \n \nO casal precisa escolher uma caixa na qual o \nobjeto caiba, de modo que sobre o menor espa-\nço livre em seu interior. \n \nA caixa escolhida pelo casal deve ser a de nú-\nmero: \n \nA) 1 \nB) 2 \nC) 3 \nD) 4 \nE) 5",
    "alternativas": {
      "E": "5",
      "A": "1",
      "B": "2",
      "C": "3"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 862,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0863",
    "numero": 2363,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Uma empresa especializada em conservação \nde piscinas utiliza um produto para tratamento \nda água cujas especificações técnicas sugerem \nque seja adicionado 1,5 mL desse produto para \ncada 1000 L de água da piscina. Essa empresa \nfoi contratada para cuidar de uma piscina de \nbase retangular, de profundidade constante \nigual a 1,7 m, com largura e comprimento iguais \na 3 m e 5 m, respectivamente. O nível da lâmina \nd’água dessa piscina é mantido a 50 cm da \nborda da piscina.  \n \nA quantidade desse produto, em mililitro, que \ndeve ser adicionada a essa piscina de modo a \natender às suas especificações técnicas é: \n \nA) 11,25 \nB) 27,00 \nC) 28,80 \nD) 32,25 \nE) 49,50",
    "alternativas": {
      "B": "27,00",
      "C": "28,80",
      "E": "49,50",
      "A": "11,25"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 863,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0864",
    "numero": 2364,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "A imagem apresentada na figura é uma cópia \nem preto e branco da tela quadrada intitulada O \npeixe, de Marcos Pinto, que foi colocada em \numa parede para exposição e fixada nos pontos \nA e B. \n \nPor um problema na fixação de um dos pontos, \na tela se desprendeu, girando rente à parede. \nApós o giro, ela ficou posicionada como ilustra-\ndo na figura, formando um ângulo de 45° com a \nlinha do horizonte. \n \n \n \n \n \n \nPara recolocar a tela na sua posição original, \ndeve-se girá-la, rente à parede, no menor ângu-\nlo possível inferior a 360°. \n \nA forma de recolocar a tela na posição original, \nobedecendo ao que foi estabelecido, é girando-\na em um ângulo de: \n \nA) 90° no sentido horário. \nB) 135° no sentido horário. \nC)180° no sentido anti-horário. \nD) 270° no sentido anti-horário. \nE) 315 no sentido horário.",
    "alternativas": {
      "C": "180° no sentido anti-horário.",
      "D": "270° no sentido anti-horário.",
      "A": "90° no sentido horário.",
      "B": "135° no sentido horário."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 864,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0865",
    "numero": 2365,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Em um teleférico turístico, bondinhos saem de \nestações ao nível do mar e do topo de uma \nmontanha.  \n \nA travessia dura 1,5 minuto e ambos os bondi-\nnhos se deslocam à mesma velocidade, Qua-\nrenta segundos após o bondinho A partir da \nestação ao nível do mar, ele cruza com o bondi-\nnho B, que havia saído do topo da montanha. \nQuantos segundos após a partida do bondinho \nB partiu o bondinho A? \n \nA) 5 \nB) 10 \nC) 15 \nD) 20 \nE) 25",
    "alternativas": {
      "B": "10",
      "C": "15",
      "D": "20",
      "E": "25"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 865,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0866",
    "numero": 2366,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "A figura ilustra uma partida de Campo Minado, o \njogo presente em praticamente todo computador \npessoal. Quatro quadrados em um tabuleiro    \n16 x 16 foram abertos, e os números em suas \nfaces indicam quantos dos seus 8 vizinhos con-\ntêm minas (a serem evitadas). O número 40 no \ncanto inferior direito é o número total de minas \nno tabuleiro, cujas posições foram escolhidas ao \nacaso, de forma uniforme, antes de se abrir \nqualquer quadrado. \n \n \n \nEm sua próxima jogada, o jogador deve esco-\nlher dentre os quadrados marcados com as \nletras P, Q, R, S e T um para abrir, sendo que \ndeve escolher aquele com menor probabilidade \nde conter uma mina. O jogador deverá abrir o \nquadrado marcado com a letra \n \nA) P \nB) Q \nC) R \nD) S \nE) T",
    "alternativas": {
      "A": "P",
      "B": "Q",
      "D": "S",
      "E": "T"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 866,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0867",
    "numero": 2367,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Para realizar a viagem dos sonhos, uma pessoa \nprecisava fazer um empréstimo no valor de RS \n5000,00. Para pagar as prestações, dispõe de, \nno máximo, R$ 400,00 mensais. Para esse valor \nde empréstimo, o valor da prestação (P) é cal-\nculado em função do número de prestações (n) \nsegundo a fórmula: \n \n \n \nSe necessário, utilize 0,005 como aproximação \npara log 1,013; 2,602 como aproximação para \nlog 400; 2,525 como aproximação para log 335.  \n \nDe acordo com a fórmula dada, o menor núme-\nro de parcelas cujos valores não comprometem \no limite definido pela pessoa é: \n \nA) 12. \nB) 14. \nC) 15. \nD) 16. \nE) 17.",
    "alternativas": {
      "A": "12.",
      "B": "14.",
      "D": "16.",
      "E": "17."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 867,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0868",
    "numero": 2368,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Raios de luz solar estão atingindo a superfície \nde um lago formando um ângulo X com a sua \nsuperfície, conforme indica a figura.  \n \nEm determinadas condições, pode-se supor que \na intensidade luminosa desses raios, na super-\nfície do lago, seja dada aproximadamente por \nI(x) = k . sen(x), sendo k uma constante, e su-\npondo-se que x está entre 0° e 90”. \n \n \n \n \nQuando X = 30º, a intensidade luminosa se \nreduz a qual percentual de seu valor máximo? \n \nA) 33% \nB) 50% \nC) 57% \nD) 70% \nE) 86%",
    "alternativas": {
      "C": "57%",
      "E": "86%",
      "A": "33%",
      "B": "50%"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 868,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0869",
    "numero": 2369,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "O fisiologista inglês Archibald Vivian Hill propôs, \nem seus estudos, que a velocidade V de contra-\nção de um músculo ao ser submetido a um peso \np é dada pela equação (p + a) (v +b) = K, com a, \nb e K constantes. \nUm fisioterapeuta, com o intuito de maximizar o \nefeito benéfico dos exercícios que recomendaria \na um de seus pacientes, quis estudar essa \nequação e a classificou desta forma: \n \n \n \nO fisioterapeuta analisou a dependência entre v \ne p na equação de Hill e a classificou de acordo \ncom sua representação geométrica no plano \ncartesiano, utilizando o par de coordenadas (p; \nV). Admita que K> 0.  \n \n(Disponível em: http://rspb.royalsocietypublishing.org. \nAcesso em: 14.jul.2015 - adaptado) \n \nO gráfico da equação que o fisioterapeuta utili-\nzou para maximizar o efeito dos exercícios é do \ntipo: \n \nA) Semirreta oblíqua. \nB) semirreta horizontal. \nC) ramo de parábola. \nD) arco de circunferência. \nE) ramo de hipérbole.",
    "alternativas": {
      "C": "ramo de parábola.",
      "D": "arco de circunferência.",
      "E": "ramo de hipérbole.",
      "B": "semirreta horizontal."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 869,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0870",
    "numero": 2370,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "A mensagem digitada no celular, enquanto você \ndirige, tira a sua atenção e, por isso, deve ser \nevitada.  \n \nPesquisas mostram que um motorista que dirige \num carro a uma velocidade constante percorre \n“às cegas” (isto é, sem ter visão da pista) uma \ndistância proporcional ao tempo gasto ao olhar \npara o celular durante a digitação da mensa-\ngem.  \n \nConsidere que isso de fato aconteça. Suponha \nque dois motoristas (X e Y) dirigem com a \nmesma velocidade constante e digitam a mes-\nma mensagem em seus celulares. Suponha, \nainda, que o tempo gasto pelo motorista X \nolhando para seu celular enquanto digita a \nmensagem corresponde a 25% do tempo gasto \npelo motorista Y para executar a mesma tarefa. \n \n(Disponível em: http://g1.globo.com.  \nAcesso em 21 Jul 2012 - adaptado) \n \nA razão entre as distâncias percorridas às ce-\ngas por X e Y, nessa ordem, é igual a: \nA) 5/4 \nB) 1/4 \nC) 4/3 \nD) 4/1 \nE) ¾",
    "alternativas": {
      "C": "4/3",
      "D": "4/1",
      "E": "¾",
      "B": "1/4"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 870,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0871",
    "numero": 2371,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Em um parque há dois mirantes de alturas dis-\ntintas que são acessados por elevador panorâ-\nmico. O topo do mirante 1 é acessado pelo ele-\nvador 1, enquanto que o topo do mirante 2 é \nacessado pelo elevador 2. Eles encontram-se a \numa distância possível de ser percorrida a pé, e \nentre os mirantes há um teleférico que os liga \nque pode ou não ser utilizado pelo visitante. \n \n \n \nO acesso aos elevadores tem os seguintes cus-\ntos: \n \n- Subir pelo elevador 1: R$ 0,15; \n- Subir pelo elevador 2: R$ 1,80; \n- Descer pelo elevador 1: R$ 0,10; \n- Descer pelo elevador 2: R$ 2,30. \n \nO custo da passagem do teleférico partindo do \ntopo do mirante 1 para o topo do mirante 2 é de \nR$ 2,00, e do topo do mirante 2 para o topo do \nmirante 1 é de R$ 2,50.  \n \nQual é o menor custo, em real, para uma pes-\nsoa visitar os topos dos dois mirantes e retornar \nao solo? \n \nA) 2,25 \nB) 3,90 \nC) 4,35 \nD) 4,40 \nE) 4,45",
    "alternativas": {
      "C": "4,35",
      "D": "4,40",
      "E": "4,45",
      "A": "2,25"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 871,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0872",
    "numero": 2372,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "O comitê organizador da Copa do Mundo 2014 \ncriou a logomarca da Copa, composta de uma \nfigura plana e o slogan “Juntos num só ritmo”, \ncom mãos que se unem formando a taça Fifa. \nConsidere que o comitê organizador resolvesse \nutilizar todas as cores da bandeira nacional \n(verde, amarelo, azul e branco) para colorir a \nlogomarca, de forma que regiões vizinhas te-\nnham cores diferentes. \n \n \n \n(Disponível em: www.pt.fifa.com.  \nAcesso em: 19 now, 2013 - adaptado) \n \nDe quantas maneiras diferentes o comitê orga-\nnizador da Copa poderia pintar a logomarca \ncom as cores citadas? \n \nA) 15 \nB) 30 \nC) 108 \nD) 360 \nE) 972",
    "alternativas": {
      "A": "15",
      "B": "30",
      "D": "360",
      "E": "972"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 872,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0873",
    "numero": 2373,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Viveiros de lagostas são construídos, por coo-\nperativas locais de pescadores, em formato de \nprismas reto-retangulares, fixados ao solo e \ncom telas flexíveis de mesma altura, capazes de \nsuportar a corrosão marinha. Para cada viveiro \na ser construído, a cooperativa utiliza integral-\nmente 100 metros lineares dessa tela, que é \nusada apenas nas laterais. \n \n \n \nQuais devem ser os valores de X e de Y, em \nmetro, para que a área da base do viveiro seja \nmáxima? \n \nA) 1 e 49 \nB) 1 e 99 \nC) 10 e 10 \nD) 25 e 25 \nE) 50 e 50",
    "alternativas": {
      "B": "1 e 99",
      "C": "10 e 10",
      "D": "25 e 25",
      "A": "1 e 49"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 873,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0874",
    "numero": 2374,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Neste modelo de termômetro, os filetes na cor \npreta registram as temperaturas mínima e má-\nxima do dia anterior e os filetes na cor cinza \nregistram a temperatura ambiente atual, ou seja, \nno momento da leitura do termômetro. \n \n \n \nPor isso ele tem duas colunas. Na da esquerda, \nos números estão em ordem crescente, de cima \npara baixo, de -30°C até 50 °C. Na coluna da \ndireita, os números estão ordenados de forma \ncrescente, de baixo para cima, de -30°C até 50 \n°C.  \n \nA leitura é feita da seguinte maneira:  \n \n- a temperatura mínima é indicada pelo nível \ninferior do filete preto na coluna da esquerda; \n \n- a temperatura máxima é indicada pelo nível \ninferior do filete preto na coluna da direita; \n \n- a temperatura atual é indicada pelo nível supe-\nrior dos filetes cinza nas duas colunas.  \n \n(Disponível em: www.if.ufrgs.br.  \nAcesso em: 28 ago. 2014 - adaptado) \n \nQual é a temperatura máxima mais aproximada \nregistrada nesse termômetro? \n \nA) 5 °C \nB) 7 °C \nC) 13°C \nD) 15 °C \nE) 19 °C",
    "alternativas": {
      "D": "15 °C",
      "E": "19 °C",
      "B": "7 °C",
      "C": "13°C"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 874,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0875",
    "numero": 2375,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Os congestionamentos de trânsito constituem um problema que aflige, todos os dias, milhares de moto-\nristas brasileiros. O gráfico ilustra a situação, representando, ao longo de um intervalo definido de tempo, \na variação da velocidade de um veículo durante um congestionamento. \n \n \n \n \n \nQuantos minutos o veículo permaneceu imóvel ao longo do intervalo de tempo total analisado? \n \nA) 4 \nB) 3 \nC) 2 \nD) 1 \nE) 0",
    "alternativas": {
      "C": "2",
      "D": "1",
      "E": "0",
      "B": "3"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 875,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0876",
    "numero": 2376,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Um brinquedo infantil caminhão-cegonha é formado por uma carreta e dez carrinhos nela transportados, \nconforme a figura. \n \n \n \n \nNo setor de produção da empresa que fabrica esse brinquedo, é feita a pintura de todos os carrinhos \npara que o aspecto do brinquedo fique mais atraente. São utilizadas as cores amarelo, branco, laranja e \nverde, e cada carrinho é pintado apenas com uma cor.  \n \nO caminhão-cegonha tem uma cor fixa. A empresa determinou que em todo caminhão-cegonha deve \nhaver pelo menos um carrinho de cada uma das quatro cores disponíveis. Mudança de posição dos car-\nrinhos no caminhão-cegonha não gera um novo modelo do brinquedo.  \n \nCom base nessas informações, quantos são os modelos distintos do brinquedo caminhão-cegonha que \nessa empresa poderá produzir? \n \nA) C6,4 \nB) C9,3 \nC) C10,4 \nD) 64 \nE) 46",
    "alternativas": {
      "D": "64",
      "E": "46",
      "A": "C6,4",
      "B": "C9,3"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 876,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0877",
    "numero": 2377,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "A avaliação de rendimento de alunos de um curso universitário baseia-se na média ponderada das notas \nobtidas nas disciplinas pelos respectivos números de créditos, como mostra o quadro: \n \n \n \nQuanto melhor a avaliação de um aluno em determinado período letivo, maior sua prioridade na escolha \nde disciplinas para o período seguinte. \n \nDeterminado aluno sabe que se obtiver avaliação “Bom” ou “Excelente” conseguirá matrícula nas disci-\nplinas que deseja. Ele já realizou as provas de 4 das 5 disciplinas em que está matriculado, mas ainda \nnão realizou a prova da disciplina I, conforme o quadro. \n \n \n \nPara que atinja seu objetivo, a nota mínima que ele deve conseguir na disciplina I é: \n \nA) 7,00. \nB) 7,38. \nC) 7,50. \nD) 8,25. \nE) 9,00.",
    "alternativas": {
      "D": "8,25.",
      "E": "9,00.",
      "A": "7,00.",
      "B": "7,38."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 877,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0878",
    "numero": 2378,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Uma rede hoteleira dispõe de cabanas simples na ilha de Gotland, na Suécia, conforme Figura 1. A es-\ntrutura de sustentação de cada uma dessas cabanas está representada na Figura 2. A ideia é permitir ao \nhóspede uma estada livre de tecnologia, mas conectada com a natureza. \n \n \n(ROMERO, L. Tendências. Superinteressante, n.315, fev. 2013 - adaptado) \nA forma geométrica da superfície cujas arestas estão representadas na Figura 2 é: \n \nA) tetraedro. \nB) pirâmide retangular. \nC) tronco de pirâmide retangular. \nD) prisma quadrangular reto, \nE) prisma triangular reto.",
    "alternativas": {
      "C": "tronco de pirâmide retangular.",
      "E": "prisma triangular reto.",
      "A": "tetraedro.",
      "B": "pirâmide retangular."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 878,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0879",
    "numero": 2379,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Um instituto de pesquisas eleitorais recebe uma encomenda na qual a margem de erro deverá ser de, no \nmáximo, 2 pontos percentuais (0,02).  O instituto tem 5 pesquisas recentes, P1 a P5, sobre o tema objeto \nda encomenda e irá usar a que tiver o erro menor que o pedido. Os dados sobre as pesquisas são os \nseguintes: \n \n \nO erro e pode ser expresso por: \n \n \nEm que σ um parâmetro e N é o número de pessoas entrevistadas pela pesquisa. \n \nQual pesquisa deverá ser utilizada? \n \nA) P1 \nB) P2 \nC) P3 \nD) P4 \nE) P5",
    "alternativas": {
      "D": "P4",
      "A": "P1",
      "B": "P2",
      "C": "P3"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 879,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0880",
    "numero": 2380,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Três alunos, X, Y e Z, estão matriculados em um curso de inglês. Para avaliar esses alunos, o professor \noptou por fazer cinco provas. Para que seja aprovado nesse curso, o aluno deverá ter a média aritmética \ndas notas das cinco provas maior ou igual a 6. Na tabela, estão dispostas as notas que cada aluno tirou \nem cada prova. \n \n \nCom base nos dados da tabela e nas informações dadas, ficará(ão) reprovado(s): \n \nA) apenas o aluno y. \nB) apenas o aluno z. \nC) apenas os alunos x e y. \nD) apenas os alunos x e z. \nE) os alunos x, y, z.",
    "alternativas": {
      "E": "os alunos x, y, z.",
      "B": "apenas o aluno z.",
      "C": "apenas os alunos x e y.",
      "D": "apenas os alunos x e z."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 880,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0882",
    "numero": 2382,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Num dia de tempestade, a alteração na profundidade de um rio, num determinado local, foi registrada \ndurante um período de 4 horas. Os resultados estão indicados no gráfico de linhas. Nele, a profundidade \nh, registrada às 13 horas, não foi anotada e, a partir de h, cada unidade sobre o eixo vertical representa \num metro. \n \n \nFoi informado que entre 15 horas e 16 horas, a profundidade do rio diminuiu 10%. Às 16 horas, qual é a \nprofundidade do rio, em metro, no local onde foram feitos os registros? \n \nA) 18 \nB) 20 \nC) 24 \nD) 36 \nE) 40",
    "alternativas": {
      "B": "20",
      "D": "36",
      "E": "40",
      "A": "18"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 882,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0883",
    "numero": 2383,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Um menino acaba de se mudar para um novo bairro e deseja ir à padaria. Pediu ajuda a um amigo que \nlhe forneceu um mapa com pontos numerados, que representam cinco locais de interesse, entre os \nquais está a padaria. Além disso, o amigo passou as seguintes instruções: a partir do ponto em que você \nse encontra, representado pela letra X, ande para oeste, vire à direita na primeira rua que encontrar, siga \nem frente e vire à esquerda na próxima rua. A padaria estará logo a seguir. \n \n \n \nA padaria está representada pelo ponto numerado com: \n \nA) 1 \nB) 2 \nC) 3 \nD) 4 \nE) 5",
    "alternativas": {
      "C": "3",
      "E": "5",
      "A": "1",
      "B": "2"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 883,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0885",
    "numero": 2385,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "A Igreja de São Francisco de Assis, obra arquitetônica modernista de Oscar Niemeyer, localizada na \nLagoa da Pampulha, em Belo Horizonte, possui abóbadas parabólicas. A seta na Figura 1 ilustra uma \ndas abóbadas na entrada principal da capela. A Figura 2 fornece uma vista frontal desta abóbada, com \nmedidas hipotéticas para simplificar os cálculos. \n \n \n \n \nQual a medida da altura H, em metro, indicada na Figura 2? \n \nA) 16/3 \nB) 31/5 \nC) 25/4 \nD) 25/3 \nE) 75/2",
    "alternativas": {
      "D": "25/3",
      "E": "75/2",
      "B": "31/5",
      "C": "25/4"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 885,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0886",
    "numero": 2386,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Dois reservatórios. A e B são alimentados por bombas distintas por um período de 20 horas. A quantida-\nde de água contida em cada reservatório nesse período pode ser visualizada na figura. \n \n \n \n \nO número de horas em que os dois reservatórios contêm a mesma quantidade de água é: \n \nA) 1 \nB) 2 \nC) 4 \nD) 5 \nE) 6",
    "alternativas": {
      "C": "4",
      "D": "5",
      "E": "6",
      "A": "1"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 886,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0887",
    "numero": 2387,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Em uma de suas viagens, um turista comprou uma lembrança de um dos monumentos que visitou. Na \nbase do objeto há informações dizendo que se trata de uma peça em escala 1: 400, e que seu volume é \nde 25 cm3.  \n \nO volume do monumento original, em metro cúbico, é de: \n \nA) 100. \nB) 400. \nC) 1600. \nD) 6250. \nE) 10 000.",
    "alternativas": {
      "A": "100.",
      "B": "400.",
      "C": "1600.",
      "E": "10 000."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 887,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0888",
    "numero": 2388,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Uma bicicleta do tipo mountain bike tem uma coroa com 3 engrenagens e uma catraca com 6 engrena-\ngens, que, combinadas entre si, determinam 18 marchas (número de engrenagens da coroa vezes o \nnúmero de engrenagens da catraca). \n \n \n \nOs números de dentes das engrenagens das coroas e das catracas dessa bicicleta estão listados no \nquadro. \n \n \n \n \nSabe-se que o número de voltas efetuadas pela roda traseira a cada pedalada é calculado dividindo-se a \nquantidade de dentes da coroa pela quantidade de dentes da catraca. \n \nDurante um passeio em uma bicicleta desse tipo, deseja-se fazer um percurso o mais devagar possível, \nescolhendo, para isso, uma das seguintes combinações de engrenagens (coroa x catraca): \n \n \n \nA combinação escolhida para realizar esse passeio da forma desejada é \n \nA) I. \nB) II. \nC) III. \nD) IV. \nE) V.",
    "alternativas": {
      "A": "I.",
      "B": "II.",
      "C": "III.",
      "D": "IV."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 888,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0889",
    "numero": 2389,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Numa avenida existem 10 semáforos. Por causa de uma pane no sistema, os semáforos ficaram sem \ncontrole durante uma hora, e fixaram suas luzes unicamente em Verde ou Vermelho. Os semáforos fun-\ncionam de forma independente; a probabilidade de acusar a cor verde é de 2/3 e a de acusar a cor ver-\nmelha é de 1/3. Uma pessoa percorreu a pé toda essa avenida durante o período da pane, observando a \ncor da luz de cada um desses semáforos.  \n \nQual a probabilidade de que essa pessoa tenha observado exatamente um sinal na cor verde? \n \nA) 10 x 2 / 310 \nB) 10 x 29 / 310 \nC) 210 / 3100 \nD) 290 / 3100 \nE) 2 / 310",
    "alternativas": {
      "A": "10 x 2 / 310",
      "B": "10 x 29 / 310",
      "C": "210 / 3100",
      "D": "290 / 3100"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 889,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0890",
    "numero": 2390,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "A manchete demonstra que o transporte de grandes cargas representa cada vez mais preocupação \nquando feito em vias urbanas. \n \nCaminhão entala em viaduto no Centro \n \nUm caminhão de grande porte entalou embaixo do viaduto no cruzamento das avenidas Borges de Me-\ndeiros e Loureiro da Silva no sentido Centro-Bairro, próximo à Ponte de Pedra, na capital. Esse veículo \nvinha de São Paulo para Porto Alegre e transportava três grandes tubos, conforme ilustrado na foto. \n \n \n \n(Disponível em: www.caminhoes-e-carretas.com. Acesso em 21 maio 2012 - Adaptado) \n \nConsidere que o raio externo de cada cano da imagem seja 0,60 m e que eles estejam em cima de uma \ncarroceria cuja parte superior está a 1,30 m do solo. O desenho representa a vista traseira do empilha-\nmento dos canos. \n \n \n \nA margem de segurança recomendada para que um veículo passe sob um viaduto é que a altura total do \nveículo com a carga seja, no mínimo, 0,50 m menor do que a altura do vão do viaduto, Considere 1,7 \ncomo aproximação para a raiz de 3. \n \nQual deveria ser a altura mínima do viaduto, em metro, para que esse caminhão pudesse passar com \nsegurança sob seu vão? \n \nA) 2,82 \nB) 3,52 \nC) 3,70 \nD) 4,02 \nE) 4,20",
    "alternativas": {
      "E": "4,20",
      "B": "3,52",
      "C": "3,70",
      "D": "4,02"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 890,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0891",
    "numero": 2391,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "O resultado de uma pesquisa eleitoral, sobre a preferência dos eleitores em relação a dois candidatos, \nfoi representado por meio do Gráfico 1. \n \n \n \n \n \nAo ser divulgado esse resultado em jornal, o Gráfico 1 foi cortado durante a diagramação, como mostra o \nGráfico 2. \n \n \n \n \nApesar de os valores apresentados estarem corretos e a largura das colunas ser a mesma, muitos leito-\nres criticaram o formato do Gráfico 2 impresso no jornal, alegando que houve prejuízo visual para o can-\ndidato B. \n \nA diferença entre as razões da altura da coluna B pela coluna A nos gráficos 1 e 2 é: \n \nA) 0 \nB) 1/2 \nC) 1/5 \nD) 2/15 \nE) 8/35",
    "alternativas": {
      "E": "8/35",
      "A": "0",
      "C": "1/5",
      "D": "2/15"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 891,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0892",
    "numero": 2392,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Pivô central é um sistema de irrigação muito usado na agricultura, em que uma área circular é projetada \npara receber uma estrutura suspensa. No centro dessa área, há uma tubulação vertical que transmite \nágua através de um cano horizontal longo, apoiado em torres de sustentação, as quais giram, sobre \nrodas, em torno do centro do pivô, também chamado de base, conforme mostram as figuras. Cada torre \nmove-se com velocidade Constante. \n \n \n \n \n \n \nUm pivô de três torres (T1, T2 e T3) será instalado em uma fazenda, sendo que as distâncias entre torres \nconsecutivas bem como da base à torre T1 são iguais a 50 m. O fazendeiro pretende ajustar as velocida-\ndes das torres, de tal forma que o pivô efetue uma volta completa em 25 horas. Use 3 como aproxima-\nção para π.  \n \nPara atingir seu objetivo, as velocidades das torres T1, T2 e T3 devem ser, em metro por hora, de \n \nA) 12, 24 e 36. \nB) 6, 12 e 18. \nC) 2, 4e 6. \nD) 300, 1200 e 2700. \nE) 600, 2400 e 5 400.",
    "alternativas": {
      "E": "600, 2400 e 5 400.",
      "A": "12, 24 e 36.",
      "B": "6, 12 e 18.",
      "D": "300, 1200 e 2700."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 892,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0893",
    "numero": 2393,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Uma desenhista projetista deverá desenhar uma tampa de panela em forma circular. Para realizar esse \ndesenho, ela dispõe, no momento, de apenas um compasso, cujo comprimento das hastes é de 10 cm, \num transferidor e uma folha de papel com um plano cartesiano. Para esboçar o desenho dessa tampa, \nela afastou as hastes do compasso de forma que o ângulo formado por elas fosse de 120°. A ponta seca \nestá representada pelo ponto C, a ponta do grafite está representada pelo ponto B e a cabeça do com-\npasso está representada pelo ponto A conforme a figura. \n \n \n \n \nApós concluir o desenho, ela o encaminha para o setor de produção. Ao receber o desenho com a indi-\ncação do raio da tampa, verificará em qual intervalo este se encontra e decidirá o tipo de material a ser \nutilizado na sua fabricação, de acordo com os dados. \n \n \n \n \nConsidere 1,7 como aproximação para a raiz de 3. \n \n \nO tipo de material a ser utilizado pelo setor de produção será \n \nA) I \nB) II \nC) III \nD) IV \nE) V",
    "alternativas": {
      "B": "II",
      "C": "III",
      "D": "IV",
      "A": "I"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 893,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0894",
    "numero": 2394,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Quanto tempo você fica conectado à internet? Para responder a essa pergunta foi criado um miniaplica-\ntivo de computador que roda na área de trabalho, para gerar automaticamente um gráfico de setores, \nmapeando o tempo que uma pessoa acessa cinco sites visitados. Em um computador, foi observado que \nhouve um aumento significativo do tempo de acesso da sexta-feira para o sábado, nos cinco sites mais \nacessados. A seguir, temos os dados do miniaplicativo para esses dias. \n \n \n \nAnalisando os gráficos do computador, a maior taxa de aumento no tempo de acesso, da sexta-feira \npara o sábado, foi no site: \n \nA) X. \nB) Y. \nC) Z. \nD) W. \nE) U.",
    "alternativas": {
      "B": "Y.",
      "C": "Z.",
      "D": "W.",
      "A": "X."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 894,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0895",
    "numero": 2395,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Para decorar uma mesa de festa infantil, um chefe de cozinha usará um melão esférico com diâmetro \nmedindo 10 cm, o qual servirá de suporte para espetar diversos doces.  \n \nEle irá retirar uma calota esférica do melão, conforme ilustra a figura, e, para garantir a estabilidade des-\nte suporte, dificultando que o melão role sobre a mesa, o chefe fará o corte de modo que o raio r da se-\nção circular de corte seja de pelo menos 3 cm. Por outro lado, o chefe desejará dispor da maior área \npossível da região em que serão afixados os doces. \nPara atingir todos os seus objetivos, o chefe deverá cortar a calota do melão numa altura h, em centíme-\ntro, igual a: \n \nA) 5 – √91/2  \nB) 10 – √91 \nC) 1 \nD) 4 \nE) 5",
    "alternativas": {
      "C": "1",
      "D": "4",
      "E": "5",
      "B": "10 – √91"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 895,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0896",
    "numero": 2396,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Um cientista, em seus estudos para modelar a pressão arterial de uma pessoa, utiliza uma função do \ntipo P(t) = A + Bcos(kt) em que A, B e K são constantes reais positivas e t representa a variável tempo, \nmedida em segundo. Considere que um batimento cardíaco representa o intervalo de tempo entre duas \nsucessivas pressões máximas. \n \nAo analisar um caso específico, o cientista obteve os dados: \n \n \n \nA função P(t) obtida, por este cientista, ao analisar o caso específico foi \n \nA) P(t) = 99 + 21 cos{3Tπt) \nB) P(t) = 78 + 42 cos(3Tπt) \nC) P(t) = 99 + 21 cos(2πt) \nD) P(t) = 99 + 21 cos(t) \nE) P(t) = 78 + 42 cos(t)",
    "alternativas": {
      "E": "P(t) = 78 + 42 cos(t)",
      "A": "P(t) = 99 + 21 cos{3Tπt)",
      "C": "P(t) = 99 + 21 cos(2πt)",
      "D": "P(t) = 99 + 21 cos(t)"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 896,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0897",
    "numero": 2397,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Uma pessoa ganhou uma pulseira formada por pérolas esféricas, na qual faltava uma das pérolas. A \nfigura indica a posição em que estaria faltando esta pérola. \n \n \n \nEla levou a jóia a um joalheiro que verificou que a medida do diâmetro dessas pérolas era 4 milímetros. \nEm seu estoque, as pérolas do mesmo tipo e formato, disponíveis para reposição, tinham diâmetros \niguais a: 4,025 mm; 4,100 mm; 3,970 mm; 4,080 mm e 3,099 mm.  \n \nO joalheiro então colocou na pulseira a pérola cujo diâmetro era o mais próximo do diâmetro das pérolas \noriginais.  \n \nA pérola colocada na pulseira pelo joalheiro tem diâmetro, em milímetro, igual a: \nA) 3,099. \nB) 3,970. \nC) 4,025. \nD) 4,080. \nE) 4,100.",
    "alternativas": {
      "C": "4,025.",
      "E": "4,100.",
      "A": "3,099.",
      "B": "3,970."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 897,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];